import leapToFreedomImg from '../../assets/leap-to-freedom.jpeg';
import tunnel57Img from '../../assets/tunnel-57.jpg';
import type { TranslationRecord } from '../types';

export const bg: TranslationRecord = {
  localeName: 'Български',
  locales: {
    en: 'Английски',
    bg: 'Български',
  },
  menuPage: {
    heading: 'Основно меню',
    body: 'Разгледайте пълната ни селекция — салати, предястия, основни ястия, десерти и авторски напитки.',
    flipbookCta: 'Отворете flipbook',
    downloadCta: 'Изтеглете PDF',
    labels: {
      weight: 'Грамаж',
      allergens: 'Алергени',
      price: 'Цена',
    },
    sections: {
      salads: {
        title: 'Салати',
        subtitle: 'Свежи зеленчуци, домашни специалитети и морски вкусотии',
      },
      starters: {
        title: 'Предястия',
        subtitle: 'Топли и студени предложения, дипове и морски деликатеси',
      },
      mains: {
        title: 'Основни ястия',
        subtitle: 'Апетитни класики от грила и авторски рецепти от сушата и морето',
      },
      desserts: {
        title: 'Десерти',
        subtitle: 'Домашни сладки, любими класики и предложения към кафето',
      },
      wine: {
        title: 'Винена листа',
        subtitle: 'Подбрани вина на чаша и бутилка',
      },
      alcohol: {
        title: 'Алкохол',
        subtitle: 'Подбрани напитки, коктейли и наливна бира',
      },
      drinks: {
        title: 'Напитки',
        subtitle: 'Безалкохолни освежители и топли напитки',
      },
    },
    allergens: {
      heading: 'Информация за алергени',
      body: 'Номерата на алергените следват регламент (ЕС) № 1169/2011. Моля, уведомете екипа ни за алергии или специален режим преди поръчка.',
      legendLabel: 'Легенда',
    },
  },
  about: {
    heading: 'Историята зад CheckPoint Charly',
    intro:
      'Добре дошли в CheckPoint Charly — място за срещи, спокойни разговори и удоволствие от малките неща. Тук можете да се отпуснете с приятели, да споделите вечеря, да се заслушате в джаз или просто да изживеете един истински приятен миг.',
    paragraphs: [
      'Ако се загледате в старите вестници и снимки по стените, ще се пренесете в друго време. Във времето на Checkpoint Charlie — контролно-пропускателния пункт, който разделяше Източен и Западен Берлин и завинаги променяше живота на всеки, успял да премине.',
      'Това беше границата между два свята, разделени само от една стена. Пресичането й беше копнеж, мечта на милиони. Докато пресата в „рая“ уверяваше хората, че отвъд стената ги чака ад, реалността бе, че мнозина загиваха от куршумите на граничарите заради стремежа си към свобода. Да направят онези няколко крачки към нов живот…',
      'На по-младите днес това звучи невероятно. Точно затова решихме нашият ресторант да носи това име — не за да натъжаваме, а за да напомняме за нещо безценно: правото да избираш къде да живееш, да пътуваш, да се срещаш с близките си без разрешение.',
      'Нашето име е почит към човешката храброст. Две знакови снимки в залата пазят тази памет по-силно от всеки разказ. Едната показва млад източногермански войник, който изоставя поста си и с един скок променя живота си. Другата, над изхода, е на възрастен мъж, който излиза от западната страна през тунел, прокопан от група студенти. Мигът, в който стъпва на свобода, е квинтесенцията на човешкия дух, отказващ да бъде окован.',
      'Тези истории са нашето мълчаливо напомняне. Те ни учат да ценим днешната свобода, която твърде често приемаме за даденост. Да ценим правото да се срещнем, да се смеем, да изберем какво да ядем, без да питаме никого. Защото точно тези мигове, осъзнати като дар, се превръщат в щастие. Заповядайте.',
    ],
    imageCaptions: {
      soldier: {
        heading: 'Скок към свободата',
        body: 'Конрад Шуман, младият граничар, заснет в мига на своя скок на 15 август 1961 г., секунди преди да стъпи в Западен Берлин.',
        alt: 'Историческа снимка на Конрад Шуман, който прескача бодливата тел към Западен Берлин.',
        src: leapToFreedomImg,
      },
      tunnel: {
        heading: 'Изходът от тунела',
        body: 'Баща, който се появява на светло през тунел, изкопан от студенти — неподвластен образ на човешката устойчивост.',
        alt: 'Историческа снимка на мъж, който излиза през тунел към Западен Берлин.',
        src: tunnel57Img,
      },
    },
  },
  meta: {
    title: 'CheckPoint Charly | Джаз ресторант в София',
    description: 'Открийте атмосферата, сезонното меню и живия джаз на ресторант CheckPoint Charly в центъра на София.',
    routes: {
      home: {
        title: 'Начало | CheckPoint Charly',
        description:
          'Преоткрийте любимия софийски ресторант, където сезонни български ястия, селектирани вина и петъчни джаз вечери създават незабравима атмосфера.',
      },
      about: {
        title: 'История | CheckPoint Charly',
        description: 'Опознайте екипа зад CheckPoint Charly и историята, вдъхновила нашето гостоприемство, кухня и музика.',
      },
      menu: {
        title: 'Меню | CheckPoint Charly',
        description: 'Разгледайте сезонните ни ястия, авторски коктейли и селекцията ни от вина.',
      },
      lunchMenu: {
        title: 'Обедно меню | CheckPoint Charly',
        description: 'Вижте актуалното обедно меню с прясно приготвени ястия всеки делничен ден в София.',
      },
      gallery: {
        title: 'Галерия | CheckPoint Charly',
        description: 'Разгледайте снимки от уютната ни зала, специалитетите, градината и джаз вечерите.',
      },
      contact: {
        title: 'Контакти | CheckPoint Charly',
        description: 'Свържете се с CheckPoint Charly в София за резервации, частни събития или специални запитвания.',
      },
      privacy: {
        title: 'Политика за поверителност | CheckPoint Charly',
        description: 'Разберете как CheckPoint Charly съхранява и защитава информацията на своите гости и посетители.',
      },
      terms: {
        title: 'Общи условия | CheckPoint Charly',
        description: 'Научете условията за използване на сайта, резервациите и отговорностите на гостите на CheckPoint Charly.',
      },
    },
  },
  navigation: {
    home: 'Начало',
    about: 'За нас',
    menu: 'Меню',
    lunchMenu: 'Обедно меню',
    gallery: 'Галерия',
    contact: 'Контакти',
    privacy: 'Политика за поверителност',
    terms: 'Общи условия',
  },
  header: {
    cta: 'Свържете се с нас',
    menuLabel: 'Меню',
    menuOpen: 'Отвори навигацията',
    menuClose: 'Затвори навигацията',
    aria: {
      themeToggle: 'Превключи темата',
      languageToggle: 'Смени езика',
    },
  },
  footer: {
    restaurantName: 'CheckPoint Charly',
    addressLine1: 'улица „Иван Вазов“ 12, София',
    country: 'България',
    viewOnMap: 'Виж на карта',
    sendMessage: 'Изпрати съобщение',
    menusHeading: 'Менюта',
    policiesHeading: 'Политики',
    privacy: 'Политика за поверителност',
    terms: 'Общи условия',
    contact: 'check_charly@abv.bg',
    copyright: '© 2025 CheckPoint Charly. Всички права запазени.',
    poweredBy: 'Дизайн и разработка от',
    followUs: 'Следвайте ни',
    contactEmail: 'check_charly@abv.bg',
    emailLabel: 'Имейл',
    mobilePhoneLabel: 'Мобилен телефон',
    mobilePhoneNumber: '+359 886 577 342',
    landlinePhoneLabel: 'Стационарен телефон',
    landlinePhoneNumber: '+359 2 988 03 70',
    openHours: {
      heading: 'Работно време',
      entries: [
        { day: 'Понеделник', hours: '11:30 – 23:30' },
        { day: 'Вторник', hours: '11:30 – 23:30' },
        { day: 'Сряда', hours: '11:30 – 23:30' },
        { day: 'Четвъртък', hours: '11:30 – 23:30' },
        { day: 'Петък', hours: '11:30 – 23:30' },
        { day: 'Събота', hours: '11:30 – 23:30' },
        { day: 'Неделя', hours: '11:30 – 23:30' },
      ],
    },
    newsletter: {
      heading: 'Бъдете в течение',
      description: 'Получавайте сезонни менюта, събития и специални предложения директно на имейла си.',
      placeholder: 'Вашият имейл адрес',
      cta: 'Абонирайте се',
      success: 'Благодарим! Ще получите нашите новини в следващото писмо.',
      error: 'Моля, въведете валиден имейл адрес.',
      subject: 'Нов абонамент за бюлетина',
    },
    facebookAria: 'Посетете CheckPoint Charly във Facebook',
    tripadvisorAria: 'Посетете CheckPoint Charly в Tripadvisor',
  },
  home: {
    hero: {
      heading: 'Checkpoint Charly — история, вкусна храна и джаз в сърцето на София',
      body:
        'Мястото, където модерната българска кухня, селектираните вина и гостоприемството са главните герои, а всяка петъчна вечер оживява с интимни live джаз изпълнения.',
      menuCta: 'Вижте менюто',
      bookingCta: 'Резервирайте маса',
    },
    booking: {
      heading: 'Резервирайте по телефона',
      body:
        'Обадете се на нашия екип, за да запазите маса за обяд, вечеря или петъчната джаз вечер. Потвърждаваме веднага.',
      callCta: 'Обадете се на +359 886 577 342',
    },
    concept: {
      heading: 'Повече от ресторант',
      body:
        'Вдъхновен от легендарния пункт на Берлинската стена, Checkpoint Charly предлага вкусна и автентична храна, съчетана с история от епоха, която днес изглежда невероятна.',
      linkLabel: 'Научете повече за нас',
    },
    reviews: {
      heading: 'Гостите обожават атмосферата',
      ratingLabel: 'Средна Google оценка',
      ratingValue: '4.8 / 5.0',
      footer: 'Автентични отзиви събрани от Google Maps',
      list: [
        {
          name: 'Мина Колева',
          text: 'Уют, джаз и обслужване с отношение. Готвачът направи годишнината ни незабравима – опитайте патицата конфит.',
        },
        {
          name: 'Даниел Петров',
          text: 'Любимото място за обед с колегите. Сезонни ястия, бързо обслужване и винаги отлични винени препоръки.',
        },
        {
          name: 'Александра Василева',
          text: 'Петъчните вечери са магия – свещи, квартет на живо и десерти, които свършват за секунди. Резервирайте отсега.',
        },
      ],
    },
    mobileHighlights: [
      { name: 'React', logo: 'react' },
      { name: 'SEO', logo: 'seo' },
      { name: 'WordPress', logo: 'wordpress' },
      { name: 'Figma', logo: 'figma' },
    ],
    stats: [
      { label: 'Средно време до пускане', value: '10 дни' },
      { label: 'Брой срещи със заинтересовани страни', value: '3 срещи' },
      { label: 'Стартирания годишно', value: '120+' },
      { label: 'Готови платежни доставчици', value: 'Stripe + други' },
    ],
    lighthouse: {
      badge: 'Google PageSpeed Insights Benchmark',
      heading: 'Перфектен резултат в Google PageSpeed Insights',
      description:
        'Оптимизираните ни процеси осигуряват 100/100 във всяка категория на PageSpeed Insights, за да излизат вашите кампании с върхова скорост, достъпност, сигурност и SEO готовност.',
      scores: [
        {
          label: 'Производителност',
          value: '100',
          description: 'Мигновено зареждане на всяко устройство',
        },
        {
          label: 'Достъпност',
          value: '100',
          description: 'Инклузивно изживяване за всички аудитории',
        },
        {
          label: 'Най-добри практики',
          value: '100',
          description: 'Модерни и сигурни практики по подразбиране',
        },
        {
          label: 'SEO',
          value: '100',
          description: 'Техническа база, която подпомага позиционирането',
        },
      ],
    },
    projects: {
      headerTitle: 'Избрани истории за старт',
      headerSubtitle:
        'Всяко партньорство комбинира премислен дизайн и надеждна доставка. Вижте как помогнахме на водеща платформа за умна мобилност да модернизира своето дигитално присъствие и да привлича клиенти по-бързо.',
      visitCta: 'Посетете сайт',
      focusAreasTitle: 'Фокус области',
      scopeTitle: 'Обхват на работа',
      projects: [
        {
          name: 'Advelo Mobility',
          subtitle: 'Изчистено дигитално изживяване за българска платформа за умни флотилии',
          description:
            'Advelo се довери на EverBranch за планиране, изграждане, пускане и поддръжка на публичния си сайт от нулата. Ние поемаме всичко — от UX концепции и тестване до деплоймънт, наличност и постоянни подобрения, за да може техният екип да се фокусира върху иновации в мобилността.',
          domain: 'https://advelo.bg',
          highlights: [
            {
              title: 'Интуитивен разказ',
              body: 'Модулни секции водят посетителите от героя през ползи, ценови сценарии и табла за управление — създадени от първоначални прототипи и валидирани с обратна връзка от екипа.',
            },
            {
              title: 'Скорост и спокойствие',
              body: 'Оптимизирани ресурси, кеширане през Cloudflare и проактивен мониторинг поддържат сайта бърз и надежден за всички заинтересовани страни денонощно.',
            },
            {
              title: 'Работещи заявки',
              body: 'Опростени формуляри, записвания за бюлетин и CTA бутони с интегриран календар стигат директно до процесите на продажби на Advelo, без пропуснати запитвания.',
            },
          ],
          deliverables: [
            'Дизайн система в тон с бранда',
            'Библиотека от адаптивни компоненти',
            'Стратегия за съдържание и UX копирайтинг',
            'Автоматизация за формуляри и бюлетин',
          ],
        },
      ],
    },
  },
  projects: {
    headerTitle: 'Избрани истории за старт',
    headerSubtitle:
      'Всяко партньорство комбинира премислен дизайн и надеждна доставка. Вижте как помогнахме на водеща платформа за умна мобилност да модернизира своето дигитално присъствие и да привлича клиенти по-бързо.',
    visitCta: 'Посетете сайт',
    focusAreasTitle: 'Фокус области',
    scopeTitle: 'Обхват на работа',
    projects: [
      {
        name: 'Advelo Mobility',
        subtitle: 'Изчистено дигитално изживяване за българска платформа за умни флотилии',
        description:
          'Advelo се довери на EverBranch за планиране, изграждане, пускане и поддръжка на публичния си сайт от нулата. Ние поемаме всичко — от UX концепции и тестване до деплоймънт, наличност и постоянни подобрения, за да може техният екип да се фокусира върху иновации в мобилността.',
        domain: 'https://advelo.bg',
        highlights: [
          {
            title: 'Интуитивен разказ',
            body: 'Модулни секции водят посетителите от героя през ползи, ценови сценарии и табла за управление — създадени от първоначални прототипи и валидирани с обратна връзка от екипа.',
          },
          {
            title: 'Скорост и спокойствие',
            body: 'Оптимизирани ресурси, кеширане през Cloudflare и проактивен мониторинг поддържат сайта бърз и надежден за всички заинтересовани страни денонощно.',
          },
          {
            title: 'Работещи заявки',
            body: 'Опростени формуляри, записвания за бюлетин и CTA бутони с интегриран календар стигат директно до процесите на продажби на Advelo, без пропуснати запитвания.',
          },
        ],
        deliverables: [
          'Дизайн система в тон с бранда',
          'Библиотека от адаптивни компоненти',
          'Стратегия за съдържание и UX копирайтинг',
          'Автоматизация за формуляри и бюлетин',
        ],
      },
    ],
  },
  story: {
    title: 'Професионалисти, обсебени от детайлите',
    intro:
      'Ние сме сплотен екип от дизайнери, инженери и проджект специалисти, който приема всеки старт като премиера. От типографията до мониторинга се стремим към най-високите стандарти в индустрията.',
    sections: [
      {
        title: 'EverBranch: нашата история и цел',
        body: [
          'Името <accent>EverBranch</accent> символизира как растем заедно с екипите, с които работим. Всяко партньорство е още едно разклонение в живо, постоянно разширяващо се дърво от реализирани идеи.',
          'Грижим се за всяко разклонение с еднакво внимание: <accent>ясна комуникация</accent>, дългосрочна ангажираност и пространство за вашата история.',
        ],
        highlights: [
          'Клиентите стават част от <accent>разрастващо се дърво</accent>',
          'Обща посока, изградена върху <accent>доверие</accent> и яснота',
        ],
      },
      {
        title: 'Всяко изстрелване под микроскоп',
        body: [
          'В студиото работят опитни експерти, които обръщат внимание на всяка дребна стъпка—<accent>контраст</accent>, микроанимации, тон на текста и настройване на аналитики.',
          'Всеки проект преминава през двойни дизайн и код ревюта, проверки за достъпност и контрол на производителността, за да бъде едновременно устойчив и впечатляващ.',
        ],
        highlights: [
          '<accent>Сениор експерти</accent> във всяко сътрудничество',
          'Дизайнерски и инженерни ревюта на всеки етап',
          '<accent>Достъпност</accent> и <accent>скорост</accent>, заложени от самото начало',
        ],
      },
      {
        title: 'Автоматизация за скорост и качество',
        body: [
          'Нашият процес е стандартизиран, автоматизиран и версиониран. <accent>Инфраструктура</accent>, тестове, миграции и контролни списъци минават през повторяеми потоци, които държат проектите в график.',
          'Когато рутината е автоматизирана, можем да вложим повече време в стратегиите, фините дизайнерски решения и завършените детайли, които отличават всяко изкарване онлайн.',
        ],
        highlights: [
          '<accent>Повторяеми наръчници</accent> и чеклисти',
          'Непрекъснато внедряване със защитни механизми',
          '<accent>По-бързи стартирания</accent> без компромис със стандарта',
        ],
      },
    ],
    closing:
      'EverBranch съществува за екипи, които очакват безупречна изработка и сигурна доставка. Комбинираме човешкия фокус с автоматизирана дисциплина, за да изглежда всяко пускане без усилие за вас.',
  },
  plans: {
    title: 'Изберете партньорството, което пасва на вашия старт',
    intro:
      'Изберете как да работим заедно — еднократна изработка, абонамент за хостинг или пълно партньорство. Описанията са в ясен език, за да решите бързо.',
    commitments: [
      {
        title: 'Във всеки план влиза',
        bullets: [
          'Начална среща за цели, аудитория и тон на комуникация',
          'Чист дизайн, адаптиран за мобилни устройства и достъпност',
          'Ясни инструкции за поддръжка и компоненти, готови за повторна употреба',
        ],
      },
      {
        title: 'Когато ние хостваме',
        bullets: [
          'Глобална мрежа за бързо зареждане и висока наличност',
          'CDN, кеширане и автоматични обновления по подразбиране',
          'Активен мониторинг',
          'Отлични резултати в Lighthouse и PageSpeed',
        ],
      },
    ],
    plans: [
      {
        name: 'Изработка на сайт',
        description: 'Създаваме сайта от нулата и ви предаваме кода, за да го хоствате където предпочитате.',
        price: 'Еднократна такса за проекта',
        assurances: [
          'Оптимизирани заглавия и описания за SEO',
          'Мигновено зареждане, настроено преди предаване',
          'Контактни форми, които изпращат директно към вашия имейл',
          'Готови Stripe плащания и чекaут потоци',
          'Секции за бюлетин, свързани с вашия имейл инструмент',
          'Подготвена структура за многоезично съдържание',
          'Светъл и тъмен режим за всяка ключова страница',
          '14 дни прозорец за корекции след пускане',
        ],
        features: [
          'Работилница за структура и послания на сайта',
          'Адаптивни страници, оптимизирани за заявки и записи',
          'Пакет за предаване с инструкции, документация и чеклист',
        ],
        cta: 'Започнете проекта',
      },
      {
        name: 'Партньорство от край до край',
        description: 'Проектираме, изграждаме, пускаме и хостваме сайта, а след това го обновяваме и развиваме заедно с вас.',
        price: 'Еднократна изработка + месечна поддръжка',
        badge: 'Най-добра производителност',
        assurances: [
          {
            text: 'Всичко от плана Изработка на сайт е включено',
            highlight: 'Изработка на сайт',
          },
          {
            text: 'Всичко от плана Хостинг е включено',
            highlight: 'Хостинг',
          },
          '100/100 резултат в Google PageSpeed Insights',
          'Гарантирана най-висока производителност',
          'Защита от спам за всяка форма',
          '24/7 поддръжка',
          'Постоянни подобрения според нуждите на бизнеса',
        ],
        features: [
          'Стратегия и дизайн, съобразени с вашия бранд',
          'Подкрепа при пускане: домейн, аналитики и интеграции',
          'Управляван хостинг с месечни подобрения и кампании',
        ],
        cta: 'Започнете проекта',
      },
      {
        name: 'Хостинг',
        description: 'Имате готов сайт? Ние го прехвърляме, хостваме, следим и обновяваме без входна такса — само месечен абонамент.',
        price: 'Само месечен абонамент',
        assurances: [
          'Включен безплатен домейн',
          'Включен безплатен SSL сертификат',
          'Включени професионални имейли',
          '100% гарантирана наличност',
          '7 резервни копия седмично',
          'Съхраняваме всички предишни версии на сайта',
          'Редовни актуализации на сигурността',
        ],
        features: [
          'Безплатна миграция, настройка на DNS и проверки преди пускане',
          'Бърз хостинг с архиви и защита',
          'Месечни актуализации на съдържание, скорост и сигурност',
        ],
        cta: 'Започнете проекта',
      },
    ],
    faqTitle: 'Често задавани въпроси',
    faq: [
      {
        question: 'Колко бързо можем да започнем?',
        answer:
          'Обикновено стартираме до два работни дни след уточнен обхват. При спешни срокове предлагаме ускорен план и изисквания за координация.',
      },
      {
        question: 'Можем ли да преминем към друг план по-късно?',
        answer:
          'Да. Често клиентите започват с изработка или само хостинг и след време преминават към пълния цикъл, когато е нужен постоянен партньор.',
      },
      {
        question: 'Работите ли с многоезичност и интеграции?',
        answer:
          'Разбира се. Многоезични версии, аналитики и интеграции с външни системи са част от всеки план. Настройваме стека според вашите инструменти.',
      },
    ],
    footer: 'Имате специфично изискване? Пишете на contact@everbranch.co и ще предложим персонализиран формат.',
  },
  gallery: {
    heading: 'Моменти от ресторанта',
    body: 'Почувствайте атмосферата — подредени маси, сезонни предложения и споделени вечери.',
    close: 'Затвори галерията',
    items: [
      {
        title: 'Вечери в двора',
        description: 'Мека светлина прави градината уютна за вечери на открито.',
      },
      {
        title: 'Градинска маса през деня',
        description: 'Слънчеви седящи места, обградени от зеленина за спокойни обеди.',
      },
      {
        title: 'Топлина в салона',
        description: 'Тъмно дърво и кадифени столове приветстват гостите вътре.',
      },
      {
        title: 'Джаз кътът',
        description: 'Инструменти и сценична светлина, готови за вечерните изпълнения.',
      },
      {
        title: 'Галерия от картини',
        description: 'Рамкираните творби и свещите създават интимна обстановка.',
      },
      {
        title: 'Характерен декор',
        description: 'Винтидж огледала и текстури добавят характер към всяко място.',
      },
    ],
  },
  contact: {
    heroHeading: 'Свържете се с нашия екип',
    heroSubheading: 'Пишете ни за частни събития, кетъринг или общи въпроси.',
    info: {
      heading: 'Посетете ни',
      description: 'Емблематичен джаз ресторант в сърцето на София с изтънчена кухня и жива музика от 2006 г.',
      addressHeading: 'Нашият адрес',
      phoneHeading: 'Нашият телефон',
      mobileLabel: 'Мобилен',
      landlineLabel: 'Стационарен',
      emailHeading: 'Нашият имейл',
      directions: 'Вземете упътвания',
      callUs: 'Обадете ни се',
      emailUs: 'Изпратете съобщение',
      mapTitle: 'Карта до CheckPoint Charly',
      viewLargeMap: 'Виж по-голяма карта',
    },
    fields: {
      name: 'Име',
      email: 'Имейл',
      phone: 'Телефон',
      subject: 'Тема',
      message: 'Вашето съобщение',
    },
    placeholders: {
      name: 'Иван Иванов',
      email: 'guest@example.com',
      phone: '+359 886 577 342',
      message: 'Споделете кога желаете да ни посетите и специални изисквания.',
      subject: 'За какво желаете да поговорим?',
      emailAddress: 'Вашият имейл адрес',
    },
    validation: {
      name: 'Моля, въведете поне две букви.',
      email: 'Моля, въведете валиден имейл.',
      phone: 'Моля, въведете валиден телефон.',
      subject: 'Моля, изберете тема.',
      message: 'Моля, добавете кратко съобщение.',
      captcha: 'Потвърдете, че не сте робот.',
    },
    submission: {
      success: 'Благодарим! Ще се свържем с вас съвсем скоро.',
      error: 'Нещо се обърка. Опитайте пак или се обадете.',
      sending: 'Изпращаме…',
      cta: 'Изпратете съобщение',
      captchaMissing: 'Спам защитата временно не работи. Обадете ни се или пишете директно.',
      subjectTemplate: 'Ново запитване от {name}',
      notProvided: 'Не е посочено',
    },
    floatingCta: 'Направете резервация',
    backToTop: 'Към началото',
  },
  infinityLoop: {
    badge: 'Цикъл на старта',
    heading: 'Как планираме и развиваме всеки сайт',
    body:
      'От първоначалния разговор до отчети след пускане, нашият екип ви води през бърз, автоматизиран процес, който държи всеки сайт в срок и в тон с бранда.',
    steps: [
      {
        label: 'Откриване',
        tagline: 'Кикоф разговор за целите на сайта, аудитории и показатели за успех.',
        highlights: ['kickoff', 'цели', 'аудитории', 'успех'],
        position: { top: '18%', left: '27%' },
      },
      {
        label: 'Планиране',
        tagline: 'График, страници и интеграции са картографирани в рамките на първите 24 часа.',
        highlights: ['график', 'интеграции', '24 часа'],
        position: { top: '50%', left: '8.5%' },
      },
      {
        label: 'Създаване',
        tagline: 'Дизайн и копирайт, съобразени с клиенти, читатели и партньори.',
        highlights: ['дизайн', 'клиенти', 'партньори'],
        position: { top: '82%', left: '27%' },
      },
      {
        label: 'Автоматизация',
        tagline: 'Хостинг, резервни копия и работни процеси са автоматизирани за моментални обновления.',
        highlights: ['хостинг', 'backup', 'работни процеси'],
        position: { top: '70%', left: '50%' },
      },
      {
        label: 'Пускане',
        tagline: 'Домейн, SSL и имейл стартират, докато екипът ни следи на живо.',
        highlights: ['домейн', 'SSL', 'имейл'],
        position: { top: '82%', left: '73%' },
      },
      {
        label: 'Проследяване',
        tagline: 'Живи табла показват регистрации, продажби и ангажираност.',
        highlights: ['табла', 'регистрации', 'продажби', 'ангажираност'],
        position: { top: '50%', left: '91.5%' },
      },
      {
        label: 'Оптимизация',
        tagline: 'Производителността се настройва с A/B готови модули и чисто SEO.',
        highlights: ['производителност', 'A/B', 'SEO'],
        position: { top: '18%', left: '73%' },
      },
      {
        label: 'Развитие',
        tagline: 'Резултатите след старта оформят плана за следващия ъпдейт.',
        highlights: ['след старта', 'инсайти', 'следващ ъпдейт'],
        position: { top: '32%', left: '50%' },
      },
    ],
  },
  privacy: {
    title: 'Политика за поверителност',
    intro: 'CheckPoint Charly уважава поверителността на всеки гост. Тук описваме какви данни събираме, защо ги използваме и как ги защитаваме.',
    sections: [
      {
        title: 'Кои сме ние',
        paragraphs: [
          'CheckPoint Charly LTD („CheckPoint Charly“, „ние“) управлява ресторант на адрес ул. „Иван Вазов“ 12, София 1000. Когато правите запитване, резервация или използвате сайта, ние сме администратор на личните данни, които ни споделяте.',
          'Можете да се свържете с нас относно поверителността на имейл check_charly@abv.bg или по пощата на горепосочения адрес.',
        ],
      },
      {
        title: 'Какви данни събираме',
        paragraphs: ['Събираме само информацията, която е необходима за организацията на посещението ви и за комуникация с вас:'],
        listTitle: 'Категории данни',
        bullets: [
          'Контактни данни (име, имейл, телефон), когато попълните контактната форма или ни се обадите.',
          'Детайли за резервация — желана дата и час, брой гости и специални изисквания.',
          'Съобщения и обратна връзка, които ни изпращате по имейл или чрез формуляри, включително прикачени файлове.',
          'Обобщена информация за посещения на сайта (страници, източник на трафик), събрана с инструменти, ориентирани към поверителността.',
          'Данни за абонамент за бюлетин, ако доброволно сте се записали.',
        ],
      },
      {
        title: 'Как използваме данните',
        paragraphs: ['Обработваме личните данни само за конкретни, законни цели:'],
        listTitle: 'Основни цели',
        bullets: [
          'Планиране и потвърждаване на резервации.',
          'Отговор на въпроси за меню, алергии, частни събития или услуги.',
          'Изпращане на новини и предложения, когато сте се абонирали (можете да се откажете по всяко време).',
          'Анализ на посещаемостта с цел подобряване на сайта и услугата.',
          'Спазване на законови изисквания, включително счетоводство и контрол от държавни органи.',
        ],
      },
      {
        title: 'Правни основания',
        paragraphs: ['Обработваме данните ви въз основа на следните правни основания по GDPR:'],
        bullets: [
          'Изпълнение на договор — когато потвърждаваме резервации и предоставяме кулинарни услуги.',
          'Законен интерес — за да отговаряме на запитвания, да водим бизнес записи и да подобряваме преживяването.',
          'Съгласие — за маркетинг комуникации и споделяне на предпочитания.',
          'Правно задължение — за счетоводни, данъчни и здравни регулации.',
        ],
      },
      {
        title: 'Срок на съхранение',
        paragraphs: ['Пазим данните само толкова дълго, колкото е необходимо:'],
        bullets: [
          'Запитвания и кореспонденция: до 12 месеца след вашето посещение или докато възникне правно изискване.',
          'Маркетингови абонаменти: до отписване или закриване на списъка.',
          'Счетоводни и данъчни записи: до 10 години според българския закон.',
        ],
      },
      {
        title: 'Споделяне с трети страни',
        paragraphs: [
          'Не продаваме лични данни. Споделяме минимално необходима информация с доверени доставчици (напр. имейл платформи, хостинг), които са обвързани с договори за конфиденциалност и GDPR защита.',
          'При законово изискване можем да предоставим данни на държавни органи като НАП или здравни инспектори.',
        ],
      },
      {
        title: 'Права на гостите',
        paragraphs: ['Ако се намирате в ЕС или Обединеното кралство, имате следните права:'],
        listTitle: 'Вашите права',
        bullets: [
          'Достъп — да получите потвърждение и копие от данните, които съхраняваме.',
          'Корекция — да поискате актуализация на неточни или непълни данни.',
          'Изтриване — да поискате изтриване, ако данните вече не са ни нужни или оттеглите съгласието си.',
          'Ограничение — да поискате временно спиране на обработката.',
          'Възражение — срещу обработка по законен интерес или директен маркетинг.',
          'Преносимост — да получите данните в структуриран формат.',
          'Жалба — до Комисията за защита на личните данни, ако смятате, че нарушаваме GDPR.',
        ],
      },
      {
        title: 'Сигурност',
        paragraphs: [
          'Използваме защитени имейл услуги, контролиран достъп и редовно обновен софтуер. Само упълномощени членове на екипа виждат детайли за резервации и запитвания.',
        ],
      },
      {
        title: 'Бисквитки и анализи',
        paragraphs: [
          'Уебсайтът ни използва основни бисквитки и инструменти за анализ с фокус върху поверителността. Можете да управлявате бисквитките чрез настройките на браузъра.',
        ],
      },
      {
        title: 'Деца',
        paragraphs: [
          'Услугите ни са насочени към пълнолетни гости. Ако разберем, че дете под 16 години ни е предоставило лични данни, ще ги изтрием незабавно.',
        ],
      },
      {
        title: 'Контакт и заявки',
        paragraphs: [
          'За въпроси или искания, свързани с лични данни, пишете на check_charly@abv.bg или се обърнете към екипа ни на място. Отговаряме до 30 дни и може да поискаме документ за самоличност преди изпълнение на заявката.',
        ],
      },
      {
        title: 'Промени в политиката',
        paragraphs: [
          'Периодично преглеждаме този документ. Новата версия се публикува на сайта с актуална дата на влизане в сила.',
        ],
      },
    ],
    footer: {
      lastUpdated: 'Последна актуализация: 31 октомври 2025 г.',
      contactIntro: 'За заявки по поверителност пишете на',
      contactEmail: 'check_charly@abv.bg',
      contactDetails: 'или ни посетете на ул. „Иван Вазов“ 12, София 1000.',
    },
  },
  terms: {
    title: 'Общи условия',
    intro:
      'Настоящите условия уреждат използването на сайта на CheckPoint Charly, подаването на запитвания за резервация и комуникацията с нашия екип. Посещавайки сайта или изпращайки съобщение, приемате описаните практики.',
    clauses: [
      {
        title: 'Данни за ресторанта',
        paragraphs: [
          'CheckPoint Charly се управлява от CheckPoint Charly LTD, регистрирано в България дружество със седалище ул. „Иван Вазов“ 12, София 1000. Официалният ни имейл е check_charly@abv.bg, а телефоните са публикувани в секция „Контакти“. ',
        ],
      },
      {
        title: 'Използване на сайта',
        paragraphs: [
          'Съдържанието на сайта е информативно и отразява текуща информация за ресторанта. Менюта, цени и промоции могат да се променят без предизвестие. Препредаването и копирането на материали е позволено само с наше писмено съгласие.',
        ],
      },
      {
        title: 'Запитвания за резервация',
        paragraphs: [
          'Данните, изпратени през формуляри, служат за подготовка на вашето посещение. Подаването на форма не гарантира резервация — ще се свържем с вас за потвърждение. Моля уведомете ни своевременно при промяна или отказ.',
        ],
      },
      {
        title: 'Отговорности на гостите',
        paragraphs: [
          'Гостите се задължават да предоставят верни контактни данни, да спазват уговорения час и правилата на ресторанта. Запазваме правото си да откажем обслужване при поведение, което застрашава персонала или останалите гости.',
        ],
      },
      {
        title: 'Алергии и хранителни изисквания',
        paragraphs: [
          'Информирайте ни предварително за алергии или специални режими. Полагаме разумни усилия за избягване на кръстосано замърсяване, но не можем да гарантираме напълно безалергенна среда.',
        ],
      },
      {
        title: 'Отговорност',
        paragraphs: [
          'Стремим се сайтът да е достъпен и точен, но не гарантираме непрекъсната работа. CheckPoint Charly не носи отговорност за косвени или последващи вреди, произтичащи от използването на сайта или забавяне при потвърждаване на резервация, освен ако това не е забранено от закона.',
        ],
      },
      {
        title: 'Интелектуална собственост',
        paragraphs: [
          'Всички лога, снимки, описания и текстове са собственост на CheckPoint Charly, освен ако не е посочено друго. Забранено е използването им без писмено разрешение.',
        ],
      },
      {
        title: 'Външни връзки',
        paragraphs: [
          'На сайта може да има връзки към външни услуги (социални мрежи, доставки и др.). Не носим отговорност за съдържанието и политиките на тези сайтове.',
        ],
      },
    ],
    footer: {
      effectiveDate: 'В сила от: 31 октомври 2025 г.',
      contactIntro: 'За въпроси относно условията пишете на',
      contactEmail: 'check_charly@abv.bg',
      contactDetails: 'или ни посетете на ул. „Иван Вазов“ 12, София 1000, България.',
    },
  },
};
